<template>
  <div class="test-paper">
    <a-card>
      <s-table
        :columns="columns"
        :data="loadData"
        :scroll="{ x:1280 }"
        class="scroll-table-wrap"
        ref="table"
        rowKey="id"
        size="default"
      >
            <span slot="action" slot-scope="text, record">
              <a @click="startExam(record)" v-if="record.status==='0'">答题</a>
              <a @click="handleView(record)" v-if="record.status==='1'">查看</a>
              <a @click="restartExam(record)" style="margin-left: 0.15rem" v-if="record.status==='1' && record.isPractice === '1'">重新答题</a>
            </span>
      </s-table>
    </a-card>
  </div>
</template>
<script>
  import STable from '@/components/table/'
  import { mapState } from 'vuex'
  import examList from '../../api/examList'
  import { getListByCode } from '@/api/dict'
  import { examStart, examRestart } from '@/api/exam'
  import myCourse from "@/api/myCourse";

  export default {
    name: 'TestPaper',
    components: {
      STable
    },
    data() {
      return {
        dictCode: 'paperType,examStatus',
        options: {},
        parameters: { testPaperPublishId: '',classId:'' },
        columns: [
          {
            title: '试卷名称',
            dataIndex: 'testPaperName',
            className: 'min-wid-m',
            scopedSlots: { customRender: 'courseDateRange' }
          },
          {
            title: '班级',
            dataIndex: 'className',
            className: 'min-wid-s',
            ellipsis: true
          },
          {
            title: '班主任',
            dataIndex: 'headmaster',
            className: 'min-wid-s',
            ellipsis: true
          },
          {
            title: '状态',
            dataIndex: 'status',
            className: 'min-wid-s',
            ellipsis: true,
            customRender: text => {
              const target = this.options.examStatus && this.options.examStatus.filter(item => text + '' === item.value)[0]
              return target && target.label
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            className: 'min-wid-m',
            scopedSlots: { customRender: 'action' }
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          const transferQuery = {}
          const order = parameter.sortOrder !== undefined ? parameter.sortOrder.substring(0, parameter.sortOrder.length - 3) : ''
          const page = {
            pageNo: parameter.pageNo,
            pageSize: parameter.pageSize,
            sortField: parameter.sortField,
            draw: order
          }
          return examList.getMyExamList(Object.assign(transferQuery, page))
        }
      }
    },
    computed: {
      ...mapState({
        userData: state => {
          if (state.user.userData.name) {
            return state.user.userData
          } else {
            return JSON.parse(localStorage.getItem('user'))
          }
        }
      })
    },
    filters: {},
    methods: {
      handleView(record) {
        const exam = {
          testPaperPublishId: record.id,
          classId: record.classId
        }
        sessionStorage.setItem('exam', JSON.stringify(exam))
        if (this.$route.name === 'myExam') {
          this.$router.push({
            path: `/home/myExamCard`,
            query: { show: '0', publishId: record.id, classId: record.classId }
          })
        } else {
          this.$router.push({
            path: `/home/examMsgCard`,
            query: { show: '0', publishId: record.id, classId: record.classId }
          })
        }
      },
      startExam(record) {
        const exam = {
          testPaperPublishId: record.id,
          classId: record.classId,
          duration: record.duration,
          isPaging: record.isPaging,
          pageSize: record.pageSize
        }
        this.parameters.testPaperPublishId = record.id
        this.parameters.classId = record.classId
        this.parameters.wholeId = record.wholeId
        examStart(this.parameters).then(res => {
          sessionStorage.setItem('exam', JSON.stringify(exam))
          this.questionNumList = res.result.list
          if (this.questionNumList !== undefined) {
            this.questionNumList.forEach(item => {
              item.active = false
            })
            this.questionNumList[0].active = true
            this.questionNumList.splice(0, 0)
          }
          if (this.$route.name === 'myExam') {
            this.$router.push('/home/myExamCard')
          } else {
            this.$router.push('/home/examMsgCard')
          }
        })
      },
      restartExam(record) {
        this.$confirm({
          title: '提示',
          content: '确定重新答题？确认后现有答题记录将被删除。',
          okText: '确定',
          cancelText: '取消',
          onOk: () => {
            examRestart({id: record.testPaperResultId}).then(() => {
              this.startExam(record)
            })
          }
        })
      }
    },
    created() {
      Promise.all([
        getListByCode({ dictCode: this.dictCode }).then(res => {
          this.options = { ...this.options, ...res.result.dictDefine }
        }),
      ])
    }

  }
</script>
<style lang="less">
  .test-paper {

  }
</style>
